import './style.sass';

import clsx from 'clsx';
import React from 'react';

import DescriptionCaseMain from './description-case-main';
import DescriptionCaseMinor from './description-case-minor';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const DescriptionCase = ({ listDescription, customClass, customChildrenClass }) => {
    return (
        <FullWrapper className="description-case">
            {listDescription.map((item, index) => (
                <div key={index} className={clsx('description-case__wrapper', customClass)}>
                    {item.title && (
                        <div
                            dangerouslySetInnerHTML={{ __html: item.title }}
                            className="description-case__title"
                        />
                    )}
                    {item.name && (
                        <div
                            dangerouslySetInnerHTML={{ __html: item.name }}
                            className="description-case__name"
                        />
                    )}
                    <div className="description-case__inner">
                        <DescriptionCaseMain item={item} />
                        <DescriptionCaseMinor
                            item={item}
                            customChildrenClass={customChildrenClass}
                        />
                    </div>
                </div>
            ))}
        </FullWrapper>
    );
};
export default DescriptionCase;
